import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Clear ")
const _hoisted_2 = { class: "visitor" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "entry-records__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_visitor_profile = _resolveComponent("visitor-profile")!
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
    "custom-class": "visitor-preview-dialog",
    width: "80%",
    "append-to-body": true,
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false))
  }, _createSlots({
    default: _withCtx(() => [
      (!_ctx.show)
        ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.trans('message.visitor_no-matched')), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
         'visitor',
         'visitor-preview',
         'grid--vertical',
         { visible: _ctx.show }
       ])
      }, [
        _createVNode(_component_el_form, {
          "label-position": "top",
          size: "small",
          model: _ctx.model,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_card, { header: "Visitor Profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_visitor_profile, { model: _ctx.model }, null, 8, ["model"])
                ]),
                _: 1
              }),
              _createVNode(_component_visiting_companies, {
                ref: "visitingCompanies",
                records: _ctx.visitCompanies
              }, null, 8, ["records"])
            ])
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_card, { class: "entry-records" }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.trans('label.entry-records')), 1),
              (!_ctx.outed)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    plain: "",
                    onClick: _ctx.manualSignOut
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trans('label.sign-out')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.entryRecords.length > 0)
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  size: "small",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.entry-time')), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.zone')), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.event')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryRecords, (entryRecord) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: entryRecord.eventTime,
                                "onUpdate:modelValue": ($event: any) => ((entryRecord.eventTime) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: entryRecord.zoneName,
                                "onUpdate:modelValue": ($event: any) => ((entryRecord.zoneName) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: entryRecord.IO,
                                "onUpdate:modelValue": ($event: any) => ((entryRecord.IO) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]))
                        }), 256))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "No entry records found."
                }))
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 2
  }, [
    (_ctx.show)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createTextVNode(" Code: " + _toDisplayString(_ctx.scannedCode) + " ", 1),
            (_ctx.outed)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  effect: "dark"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        }
      : undefined
  ]), 1032, ["modelValue"]))
}